import { Outlet, createFileRoute, notFound } from "@tanstack/react-router";
import { z } from "zod";

import { courseQueryOptions } from "~/lib/functions/admin-learning";

export const Route = createFileRoute("/admin/courses/$courseId")({
  staticData: { title: "Course" },
  loader: async ({ context, params }) => {
    if (!z.string().uuid().safeParse(params.courseId).success) {
      throw notFound();
    }
    const course = await context.queryClient.ensureQueryData(
      courseQueryOptions(params.courseId),
    );
    if (!course) throw notFound();
    return { title: course.title };
  },
  component: () => <Outlet />,
});
